// extracted by mini-css-extract-plugin
module.exports = {"mainChaild":"RequestsRepairPage_mainChaild__FHT8v","btnTabs":"RequestsRepairPage_btnTabs__A27lP"};